import React, { Component } from "react";
import PropTypes from 'prop-types'
import loadable from '@loadable/component';

const LoadableAircraftGalleryCarousel = loadable(() => import(/* webpackChunkName: "gatsby-AircraftCarousel" */ 'components/carousel/aircraft/index'));

class Carousel extends Component {
  render() {
    const { images } = this.props;

    if (images) {
      return (
        <LoadableAircraftGalleryCarousel
          images={images}
        />
      );
    } else return null;
  }
}

Carousel.propTypes = {
  images: PropTypes.array
}

export default Carousel;
